const baseURL = 'https://mesas.komerzy.com/';

export default baseURL;
